/** @typedef {import('../../lib/types.js').NoteContentBlock} NoteContentBlock */

/** @type {NoteContentBlock[]} */
export const meetingProductSyncIntroDemoContent = [
  { type: 'heading', level: 1, text: 'Product sync — action items' },
  {
    type: 'paragraph',
    text: 'Hour-long review with Alex Morgan facilitating. Covered launch timeline, design review scheduling, and customer pilot feedback on notes + briefing together.',
  },
  { type: 'heading', level: 2, text: 'Decisions' },
  {
    type: 'bullets',
    items: [
      'Ship inbox folder navigation before custom labels or smart folders',
      'Design review locked for Thursday 2pm — deck due Tuesday EOD',
      'Pilot customers get Mission Control notes first; briefing stays on rail',
      'Transcribe meeting CTA stays primary; paste-link flows to secondary menu',
    ],
  },
  { type: 'heading', level: 2, text: 'Launch timeline' },
  {
    type: 'numbered',
    items: [
      'May 20 — internal dogfood on Mission Control notes',
      'May 24 — design review sign-off',
      'May 28 — pilot invite for three accounts',
      'June 3 — GA behind feature flag if metrics hold',
    ],
  },
  { type: 'heading', level: 2, text: 'Customer signals' },
  {
    type: 'paragraph',
    text: 'Two pilot admins asked for longer meeting transcripts in-line (not truncated in the list). Enterprise prospect wants SSO on notes export — parked for Q3.',
  },
]
